export const inWindowTool = () => typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.localStorage !== 'undefined';
